export default __webpack_public_path__ + "static/media/doctor-7.20a3be16.jpg";